import { render } from "./vipCardStatistics.vue?vue&type=template&id=1f80e2cf&scoped=true&ts=true"
import script from "./vipCardStatistics.vue?vue&type=script&lang=ts"
export * from "./vipCardStatistics.vue?vue&type=script&lang=ts"

import "./vipCardStatistics.vue?vue&type=style&index=0&id=1f80e2cf&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f80e2cf"]])

export default __exports__